import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from '../../../redux/ducks/SnackbarDucks';
import SnackMessage from '../SnackMessage';

export let displayed = [];

export const resetDisplayed = () => {
  displayed = [];
};

export const storeDisplayed = (id) => {
  displayed = [...displayed, id];
};

export const removeDisplayed = (id) => {
  displayed = [...displayed.filter((key) => id !== key)];
};

function Notifier() {
  const dispatch = useDispatch();
  const notifications = useSelector((store) => store.snackbar.notifications);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    notifications.forEach(
      ({ key, message, options = {}, dismissed = false }) => {
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
          return;
        }

        // display snackbar using notistack
        enqueueSnackbar(message, {
          key,
          ...options,
          content: (key, message) => (
            <SnackMessage
              id={key}
              key={key}
              message={message}
              variant={options?.variant}
            />
          ),
          preventDuplicate: true,
          onExited: (event, myKey) => {
            // remove this snackbar from redux store
            dispatch(removeSnackbar(myKey));
            removeDisplayed(myKey);
          },
        });

        // keep track of snackbars that we've displayed
        storeDisplayed(key);
      }
    );
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
}

export default Notifier;
